import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { HelmetProvider } from '@dr.pogodin/react-helmet';
import { AuthProvider } from './contexts/AuthContext';
import { PurchasesProvider } from './contexts/PurchasesContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { RouteController } from './components/common/RouteController';
import { Auth } from './pages/Auth';
import { Home } from './pages/Home';
import { Book } from './pages/Book';
import { Chapter } from './pages/Chapter';
import { Profile } from './pages/Profile';
import { PurchaseFinalize } from './pages/PurchaseFinalize';
import { NotFound } from './pages/NotFound';
import { UnsubscribeEmail } from './pages/UnsubscribeEmail';
import { Hubs } from './pages/hub/Hubs';
import {
  BossCeoRomanceHub,
  BestBillionaireRomanceHub,
  BillionaireRomanceReadOnlineHub,
  BillionaireRomanceHub,
} from './pages/hub';
import { initSentry } from './utils/sentry';
import './localization/i18n';
import { getFontSizeForScreen } from './utils/fontUtils';

// Initialize Sentry
if (process.env.NODE_ENV === 'production') {
  initSentry();
}

function App() {
  return (
    <HelmetProvider>
      <Router basename={process.env.PUBLIC_URL}>
        <ThemeProvider>
          <AuthProvider>
            <PurchasesProvider>
              <RouteController>
                <Routes>
                  <Route path="/auth" element={<Auth />} />
                  <Route
                    path="/purchase-finalize"
                    element={<PurchaseFinalize />}
                  />
                  <Route path="/" element={<Home />} />
                  <Route path="/books/:bookSlug" element={<Book />} />
                  <Route
                    path="/books/:bookSlug/chapter/:chapterNumber"
                    element={<Chapter />}
                  />
                  <Route path="/profile" element={<Profile />} />
                  <Route
                    path="/unsubscribe-email"
                    element={<UnsubscribeEmail />}
                  />
                  <Route path="/unsubscribe" element={<UnsubscribeEmail />} />
                  <Route path="/hub" element={<Hubs />} />
                  <Route
                    path="/hub/billionaire-romance"
                    element={<BillionaireRomanceHub />}
                  />
                  <Route
                    path="/hub/best-billionaire-romance-books"
                    element={<BestBillionaireRomanceHub />}
                  />
                  <Route
                    path="/hub/billionaire-romance-read-online"
                    element={<BillionaireRomanceReadOnlineHub />}
                  />
                  <Route
                    path="/hub/boss-ceo-romance"
                    element={<BossCeoRomanceHub />}
                  />
                  <Route path="/404" element={<NotFound />} />
                  <Route path="*" element={<NotFound />} />
                </Routes>
                <Toaster
                  position="top-right"
                  toastOptions={{
                    duration: 2000,
                    style: {
                      borderRadius: '8px',
                      fontSize: getFontSizeForScreen('normal'),
                    },
                    success: {
                      iconTheme: {
                        primary: '#10b981',
                        secondary: '#ffffff',
                      },
                    },
                    error: {
                      iconTheme: {
                        primary: '#ef4444',
                        secondary: '#ffffff',
                      },
                    },
                  }}
                />
              </RouteController>
            </PurchasesProvider>
          </AuthProvider>
        </ThemeProvider>
      </Router>
    </HelmetProvider>
  );
}

export default App;
